import * as actionTypes from '../../actions/actionTypes';
import {cloneDeep} from "lodash";

const initialState = {
    markSheetRequests: [],
    loadingMarkSheetRequests: false,
    markSheetTypes: [],
    loadingMarkSheetTypes: false,
    markSheetSubjects: [],
    loadingMarkSheetSubjects: false,

    waitingForSendMarkSheetRequestResult: false
};

////////////////////////////////////////////////////////////////

const loadMarkSheetRequests = (state) => {
    return {
        ...state,
        loadingMarkSheetRequests: true
    }
}

const setMarkSheetRequests = ( state, action ) => {
    let tmp = [...action.markSheetRequests]
    return {
        ...state,
        markSheetRequests: tmp,
        loadingMarkSheetRequests: false
    }
}

////////////////////////////////////////////////////////////////

const updateMarkSheetRequest = ( state, action ) => {
    const markSheetRequestsCopy = state.markSheetRequests.map(m => {
        let markSheetRequestCopy;
        if(m.id === action.markSheetRequest.id){
            markSheetRequestCopy = action.markSheetRequest;
        } else {
            markSheetRequestCopy = cloneDeep(m)
        }
        return markSheetRequestCopy;
    })
    return {
        ...state,
        markSheetRequests: markSheetRequestsCopy,
    }
}

////////////////////////////////////////////////////////////////

const loadMarkSheetTypes = (state) => {
    return {
        ...state,
        loadingMarkSheetTypes: true
    }
}

const setMarkSheetTypes = ( state, action ) => {
    let tmp = [...action.markSheetTypes]
    return {
        ...state,
        markSheetTypes: tmp,
        loadingMarkSheetTypes: false
    }
}

////////////////////////////////////////////////////////////////

const loadMarkSheetSubjects = (state) => {
    return {
        ...state,
        loadingMarkSheetSubjects: true
    }
}

const setMarkSheetSubjects = ( state, action ) => {
    let tmp = [...action.markSheetSubjects]
    return {
        ...state,
        markSheetSubjects: tmp,
        loadingMarkSheetSubjects: false
    }
}


////////////////////////////////////////////////////////////////

const sendMarkSheetRequest = (state) => {
    return {
        ...state,
        waitingForSendMarkSheetRequestResult: true
    }
}

const receiveSendMarkSheetRequestResult = (state, action) => {
    let requests = state.markSheetRequests;
    requests.unshift(action.newMarkSheetRequest);

    return {
        ...state,
        waitingForSendMarkSheetRequestResult: false,
        markSheetRequests: requests
    }
}

////////////////////////////////////////////////////////////////

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.LOAD_MARK_SHEET_REQUESTS: return loadMarkSheetRequests( state );
        case actionTypes.SET_MARK_SHEET_REQUESTS: return setMarkSheetRequests( state, action );
        case actionTypes.UPDATE_MARK_SHEET_REQUEST: return updateMarkSheetRequest( state, action );

        case actionTypes.LOAD_MARK_SHEET_TYPES: return loadMarkSheetTypes( state );
        case actionTypes.SET_MARK_SHEET_TYPES: return setMarkSheetTypes( state, action );
        case actionTypes.LOAD_MARK_SHEET_SUBJECTS: return loadMarkSheetSubjects( state );
        case actionTypes.SET_MARK_SHEET_SUBJECTS: return setMarkSheetSubjects( state, action );

        case actionTypes.SEND_MARK_SHEET_REQUEST: return sendMarkSheetRequest( state );
        case actionTypes.RECEIVE_SEND_MARK_SHEET_REQUEST_RESULT: return receiveSendMarkSheetRequestResult( state, action );
        default: return state;
    }
};
export default reducer;